export function candidateName(candidate) {
  const first = String(candidate?.firstname || "").trim().toLocaleLowerCase("fr-FR").replace(/(^|[\s’'-])(\p{L})/gu, (_, separator, letter) => separator + letter.toLocaleUpperCase("fr-FR"));
  const last = String(candidate?.lastname || "").trim().toLocaleUpperCase("fr-FR");
  return [first, last].filter(Boolean).join(" ");
}
